export const localeArray = [
  { i18n_form: 'en', language: 'English', subdomain: 'www', value: 'en' },
  { i18n_form: 'es', language: 'Español', subdomain: 'es', value: 'es' },
  { i18n_form: 'pt', language: 'Português', subdomain: 'pt', value: 'pt' },
  { i18n_form: 'ru', language: 'Русский', subdomain: 'ru', value: 'ru' },
  { i18n_form: 'ja', language: '日本語', subdomain: 'ja', value: 'ja' },
  { i18n_form: 'tw', language: '中文 (繁體)', subdomain: 'tw', value: 'tw' },
];
